import CryptoJS from 'crypto-js'; // npm: https://www.npmjs.com/package/crypto-js doc: https://cryptojs.gitbook.io/docs/
import ConfigManager from '@/config/ConfigManager.js';

export function Encrypt() {
    this.secret = 'Sx%CqfZVZz5qn$ER8ht*nsfe_kj_tAdJqxX?z&&A4@v9=$5nE-XP9XkjM5DWZ6L%' + ConfigManager.getAppId();

    this.encrypt = function (text) {
        let data = CryptoJS.AES.encrypt(text, this.secret);
        return data.toString();
    };

    this.decrypt = function (encrypted) {
        let data = CryptoJS.AES.decrypt(encrypted, this.secret);
        return data.toString(CryptoJS.enc.Utf8);
    };

    this.encryptQueryString = function (text, module) {
        let secret = 'Sx%CqfZVZz5qn$ER8ht*nsfe_kj_tAdJqxX?z&&A4@v9=$5nE-XP9XkjM5DWZ6L%' + module
        let data = CryptoJS.AES.encrypt(text, secret);
        return data.toString();
    }

    this.decryptQueryString = function(encrypted, module){
        let secret = 'Sx%CqfZVZz5qn$ER8ht*nsfe_kj_tAdJqxX?z&&A4@v9=$5nE-XP9XkjM5DWZ6L%' + module
        let data = CryptoJS.AES.decrypt(encrypted, secret);
        return data.toString(CryptoJS.enc.Utf8);
    }
}
